/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Client_IdInputs */

const cs_sreality_client_id = /** @type {(inputs: Sreality_Client_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK client id`)
};

const en_sreality_client_id = /** @type {(inputs: Sreality_Client_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RK client id`)
};

/**
* | output |
* | --- |
* | "RK client id" |
*
* @param {Sreality_Client_IdInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_client_id = /** @type {((inputs?: Sreality_Client_IdInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Client_IdInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_client_id(inputs)
	return cs_sreality_client_id(inputs)
});